module.exports = __webpack_public_path__ + "media/images/thumb-up-431a7d09f0c34fc76980a925ad280ac7.svg";